import { gql } from "@apollo/client";
const FAVORITES = gql`
  query {
    favorites {
      __typename
      ... on Favorite {
        product {
          id
          name
          description
          price
          shine
          stock
          url_image
          ref_image
          favorite {
            id
            product_id
          }
        }
      }
    }
  }
`;
export { FAVORITES };
